import axios from '@axios'

export default {
  namespaced: true,
  state: {
    upcoming_list: [],
    museums_objects_info: {},
    request_is_success: null,
    request_error_msg: null,
  },
  getters: {
    getUpcomingList: state => state.upcoming_list,
    getMuseumObjectsInfo: state => state.museums_objects_info,
    getRequestStatus: state => state.request_is_success,
    getRequestErrorMsg: state => state.request_error_msg,
  },
  mutations: {
    set_on_request_success(state, data) {
      state.upcoming_list = data.result
      if (data.payload !== undefined) {
        state.museums_objects_info = data.payload
      }
      state.request_is_success = true
      state.request_error_msg = null
    },

    // Начало загрузки. Уже показанный список НЕ стираем: при возврате со
    // страницы заявки он в хранилище есть, и обнулять его — значит показать
    // пустой экран с крутилкой ради тех же самых заявок. Список остаётся на
    // месте, а обновление идёт фоном и подменяет данные, когда придёт ответ.
    // Крутилку показываем только когда показывать действительно нечего.
    set_request_init(state) {
      state.request_error_msg = null
      if (!state.upcoming_list.length) {
        state.request_is_success = null
        state.museums_objects_info = {}
      }
    },

    // Данные точно изменились (заявку аннулировали, отправили в архив,
    // поправили) — показанный список больше не годится, сбрасываем его, чтобы
    // страница не мигнула устаревшими заявками.
    drop_cache(state) {
      state.upcoming_list = []
      state.museums_objects_info = {}
      state.request_is_success = null
      state.request_error_msg = null
    },
    set_on_request_error(state, error) {
      state.request_error_msg = error

      // Список, загруженный раньше, при сбое оставляем: система заявок
      // отваливается по таймауту, и терять из-за этого уже показанные заявки
      // ни к чему. Ошибку показываем, только когда показывать нечего.
      if (!state.upcoming_list.length) {
        state.museums_objects_info = {}
        state.request_is_success = false
      }
    },
  },
  actions: {
    fetchUpcoming({ commit }) {
      commit('set_request_init')

      return new Promise((resolve, reject) => {
        const data = JSON.stringify({
          language: 'ru',
        })
        const postData = new FormData()
        postData.append('data', data)
        postData.append('action', 'get_upcoming')
        axios({
          method: 'post',
          url: '/api/v1/actions/',
          data: postData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            if (response.status === 200) {
              commit('set_on_request_success', response.data.data)
              resolve(response)
            }
          })
          .catch(error => {
            commit('set_on_request_error', 'Система заявок не ответила')
            reject(error)
          })
      })
    },
  },
}
